<template>
  <div class="player">
    <div class="avatar">
      <img class="user" :src="info.teacher ? info.teacher.image : ''" alt="teacherAvatar"/>
      <img v-if="state === 1 || state === 3 || state === 4" @click="play" class="play" src="../../assets/icons/share_play.svg" alt="play"/>
      <img v-if="state === 2" @click="pause" class="pause" src="../../assets/icons/share_pause.svg" alt="pause"/>
    </div>

    <div class="info">
      <h3>{{ info.chapterName || '与微课一起成长' }}</h3>
      <h5>{{ `来自《${info.courseName || 'WPS课程'}》` }}</h5>
      <div class="progressBar">
        <div class="line"></div>
        <div class="progress" :style="{width: progressWidth}"/>
        <p><span>{{ played | formatSeconds2 }}</span><em>{{ limit | formatSeconds2 }}</em></p>
      </div>
    </div>

    <audio id="trial" :src="info.tryBvo ? info.tryBvo.video || testAudioSrc : testAudioSrc" ref="player"></audio>
  </div>
</template>

<script>
import formatSeconds2 from '../../filters/format-seconds-2'

const testAudioSrc = 'http://boscdn.bpc.baidu.com/v1/developer/c6dd4495-d0b3-4f16-96d5-6e5911897429.mp3'

export default {
  props: ['info', 'fromShare'],

  data () {
    return {
      testAudioSrc,
      state: 1, // 1：可播放 2：暂停 3：缓冲中 4：准备重播
      duration: 0,
      played: 0,
      progressWidth: 0,
      limit: 0
    }
  },

  filters: {
    formatSeconds2
  },

  watch: {
    info (n) {
      if (n.tryBvo) {
        this.limit = n.tryBvo.length
      }
    }
  },

  mounted () {
    this.$refs.player.addEventListener('canplay', (e) => {
      this.state = 1
      this.duration = e.target.duration
    })
    this.$refs.player.addEventListener('pause', () => {
      this.disableMonit()
      this.state = 1
    })
    this.$refs.player.addEventListener('playing', (e) => {
      this.monit()
      this.state = 2
    })
    this.$refs.player.addEventListener('ended', () => {
      this.setCurrent()
    })

    // 限制音频播放的长度
    this.$refs.player.addEventListener('timeupdate', () => {
      if (this.$refs.player.currentTime >= this.limit) {
        this.$refs.player.pause()
        this.played = this.limit
        this.setReplay()
      }
    })
  },

  methods: {
    play () {
      if (this.$refs.player.currentTime >= this.limit) {
        this.$refs.player.currentTime = 0
      }
      this.$refs.player.play()
    },

    pause () {
      this.$refs.player.pause()
    },

    setCurrent () {
      this.played = this.$refs.player.currentTime
      // this.progressWidth = this.$refs.player.currentTime / this.$refs.player.duration * 100 + '%'
      this.progressWidth = this.$refs.player.currentTime / this.limit * 100 + '%'
    },

    setReplay () {
      // 将进度条拉到最长
      this.progressWidth = '100%'
      this.state = 4
    },

    monit () {
      this.monitor = setInterval(() => {
        this.setCurrent()
      }, 900)
    },

    disableMonit () {
      clearInterval(this.monitor)
    }
  }
}
</script>

<style lang="scss" scoped>
@charset "UTF-8";
@import "../../style/main";

$global-width: 750;

#trial {
  position: absolute;
  visibility: hidden;
}

.player {
  height: rem(178);
  width: rem(538);
  padding: rem(20) 0;
  border: rem(1) solid #FFC9A3;
  border-radius: rem(8);
  background-color: #FFF9F4;
  overflow: hidden;

  .avatar {
    position: relative;
    display: inline-block;
    height: 100%;
    width: rem(152);
    margin-right: rem(22);
    vertical-align: middle;

    .user {
      height: rem(180);
      width: rem(130);
      margin-left: rem(20);
      border-radius: rem(4);
    }

    .play,
    .pause,
    .caching {
      position: absolute;
      right: rem(32);
      top: 0; bottom: 0;
      margin: auto 0;
      height: rem(66);
      width: rem(66);
    }

    .caching {
      animation: caching 1000ms infinite linear;
    }
  }

  .info {
    position: relative;
    display: inline-block;
    height: 100%;
    width: rem(352);
    vertical-align: middle;

    h3 {
      color: #333;
      font-size: rem(28);
      line-height: rem(40);
    }

    h5 {
      color: #999;
      font-size: rem(22);
      line-height: rem(30);
      margin-bottom: rem(30);
    }

    .progressBar {
      position: absolute;
      bottom: 0;
      left: 0;
      height: rem(40);
      width: rem(345);

      .line {
        position: absolute;
        top: 0;
        left: 0;
        height: rem(2);
        width: 100%;
        background-color: #ADADAD;
      }

      .progress {
        position: absolute;
        left: 0;
        height: rem(3);
        background-color: #FF8900;
      }

      p {
        margin-top: rem(16);

        span {
          float: left;
          color: #999;
          font-size: rem(22);
        }

        em {
          float: right;
          color: #999;
          font-size: rem(22);
        }
      }
    }
  }
}

@keyframes caching {
  to { transform: rotate(359deg) }
}
</style>
